// 入口函数，在页面加载完成后执行
function main() {

  Alpine.store('header', {
    //#region data
    searchForm: {
      // 搜索栏搜索
      search: '',
    },
    searchShow: false, // 是否打开搜索框
    //#endregion data

    // 搜索框
    searchOpen() {
      this.searchShow = true
    },
    searchClose() {
      this.searchShow = false
    },
    search() {
      this.searchShow = false
      const search = this.searchForm.search
      window.location.href = '/search?type=product&q=' + search
    },
    //#endregion methods
  })

  Alpine.data('gocHeaderMobile', function () {

    return {
      //#region data
      menuListShow: false, // 是否显示菜单栏弹窗
      cartNumShow: true, // 是否显示购物车数量
      cartListShow: false, // 是否购物车详情显示下拉
      userListShow: false, // 是否显示用户列表弹窗
      isLogin: false, // 是否登录状态
      isTop: false, // 是否固定导航栏
      timer: '', // 购物车弹窗定时器
      searchForm: {
        // 搜索栏搜索
        search: '',
      },
      searchShow: false, // 是否打开搜索框
      //#endregion data

      init() {
        // 监听是否滚动
        window.addEventListener('scroll', this.scrollToTop, true)
        // 监听是否刷新
        window.addEventListener('load', this.windowOnload, true)
      },

      //#region methods
      // 用户注销
      async logout() {
        window.location.href = '/account/logout'
      },
      toggleMenuList() {
        if (this.menuListShow) {
          this.menuListShow = false
          document.body.style.overflow = ''
        } else {
          this.menuListShow = true
          document.body.style.overflow = 'hidden'
        }
      },
      // 打开菜单栏弹窗
      openMenuList() {
        this.menuListShow = true
        document.body.style.overflow = 'hidden'
      },
      // 关闭菜单栏弹窗
      closeMenuList() {
        this.menuListShow = false
        document.body.style.overflow = ''
      },
      // 页面滚动事件
      scrollToTop() {
        const scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop
        // 为了计算距离顶部的高度，当高度大于56显示回顶部图标，小于56则隐藏
        this.isTop = scrollTop > 56
      },
      // 页面刷新事件
      windowOnload() {
        const scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop
        // 为了计算距离顶部的高度，当高度大于56显示回顶部图标，小于56则隐藏
        this.isTop = scrollTop > 56
      },
      // 购物车弹窗背景点击关闭购物车弹窗
      clickOverlay() {
        this.cartWindow = false
      },
      // 购物车弹窗关闭按钮点击关闭购物车弹窗
      clickCloseIcon() {
        this.cartWindow = false
      },
      // 搜索框
      searchOpen() {
        this.searchShow = true
        this.closeMenuList()
      },
      searchClose() {
        this.searchShow = false
      },
      search() {
        this.searchShow = false
        const search = this.searchForm.search
        window.location.href = '/search?type=product&q=' + search
      },
      //#endregion methods
    }
  })
}

document.addEventListener('alpine:init', main)
